import { Button, PlusIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const AddViewButton: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Button
      key="view-add"
      type="primary"
      icon={<PlusIcon />}
      onClick={async () => {
        navigate(`/reporting/machine/status/views/new`);
      }}
    >
      {t("reporting.machinestatus.view.actions.add.button")}
    </Button>
  );
};
